module.exports = __webpack_public_path__ + "static/img/nuxin_fu.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/nuxin_fu.jpg
// module id = dxC2
// module chunks = 0